import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  baseURL: "https://decadb.pesa.solutions/api/",
  //baseURL: "http://localhost:3320/api/",
});

const writeAxiosInstance = axios.create({
  baseURL: "https://decadb.pesa.solutions/api/",
  //baseURL: "http://localhost:3320/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;
